import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

const RING_RADIUS = 42
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS

/**
 * Card KPI con anello circolare SVG per la percentuale gestita da Nora.
 * Mostra un progress ring animato con il valore percentuale al centro.
 * @param {Object} props - Proprietà del componente
 * @param {Object} props.handledPercentage - Dati percentuali gestione Nora
 * @param {number} props.handledPercentage.perc - Percentuale gestita
 * @param {number} props.handledPercentage.totalHandled - Totale gestite
 * @param {number} props.handledPercentage.totalConversationsLength - Totale conversazioni (escluse inoltrate)
 * @returns {JSX.Element} Card KPI con anello percentuale
 */
export const HandledPercentageNora = ({ handledPercentage }) => {
  const percentage = handledPercentage?.perc || 0
  const clampedPerc = Math.min(percentage, 100)
  const strokeOffset = RING_CIRCUMFERENCE - (clampedPerc / 100) * RING_CIRCUMFERENCE
  const hasData = !!handledPercentage?.totalHandled

  return (
    <div className="ncard nkpi-card nkpi-card--green">
      <div className="ncard__head">
        <div
          className="ncard__ico"
          style={{ background: 'var(--success-tint)', color: 'var(--success)' }}
        >
          <i className="pi pi-check-circle" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.gestiteDaNora}</h3>
        </div>
      </div>
      <div className="ncard__body" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {hasData ? (
          <>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <svg width={130} height={130} viewBox="0 0 100 100" style={{ display: 'block' }}>
                <circle
                  cx="50"
                  cy="50"
                  r={RING_RADIUS}
                  stroke="var(--surface-3)"
                  strokeWidth="10"
                  fill="none"
                />
                <circle
                  cx="50"
                  cy="50"
                  r={RING_RADIUS}
                  stroke="var(--success)"
                  strokeWidth="10"
                  fill="none"
                  strokeDasharray={RING_CIRCUMFERENCE}
                  strokeDashoffset={strokeOffset}
                  transform="rotate(-90 50 50)"
                  strokeLinecap="round"
                  style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }}
                />
              </svg>
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 22,
                  fontWeight: 700,
                  color: 'var(--success)',
                  letterSpacing: '-0.02em'
                }}
              >
                {clampedPerc}%
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: 'var(--ink-900)',
                  marginBottom: 2
                }}
              >
                {handledPercentage.totalHandled}/{handledPercentage.totalConversationsLength}{' '}
                {t.conversationPlural}
              </div>
              <div style={{ fontSize: 11, color: 'var(--ink-400)', lineHeight: 1.4 }}>
                {t.escluseConversazioniInoltrate}
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <svg width={130} height={130} viewBox="0 0 100 100" style={{ display: 'block' }}>
                <circle
                  cx="50"
                  cy="50"
                  r={RING_RADIUS}
                  stroke="var(--surface-3)"
                  strokeWidth="10"
                  fill="none"
                />
              </svg>
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 14,
                  fontWeight: 600,
                  color: 'var(--warning)'
                }}
              >
                --
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, color: 'var(--warning)', fontWeight: 500 }}>
                {t.nessunaConversazioneNelPeriodo}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
